import { Box, Button, Container, Stack, Typography } from '@mui/joy';
import { FadeIn } from './FadeIn';

function TelegramIcon({ color = 'white' }) {
    return (
        <svg
            width="20"
            viewBox="0 0 543 450"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.3284 193.722C183.089 130.217 280.285 88.35 328.917 68.1222C467.773 10.3674 496.625 0.334815 515.431 0.00353222C519.568 -0.0693298 528.816 0.95574 534.806 5.8167C539.865 9.92121 541.257 15.4658 541.923 19.3573C542.589 23.2488 543.418 32.1138 542.759 39.0407C535.234 118.102 502.675 309.965 486.111 398.515C479.102 435.984 465.301 448.548 451.941 449.777C422.905 452.449 400.856 430.588 372.733 412.153C328.727 383.306 303.866 365.349 261.15 337.2C211.784 304.669 243.786 286.789 271.919 257.569C279.282 249.921 407.215 133.556 409.691 123C410.001 121.68 410.288 116.759 407.365 114.16C404.441 111.562 400.126 112.45 397.012 113.157C392.599 114.159 322.298 160.625 186.11 252.556C166.155 266.259 148.081 272.935 131.887 272.585C114.034 272.199 79.6928 262.491 54.1636 254.192C22.8511 244.014 -2.03552 238.632 0.131547 221.346C1.26029 212.343 13.6592 203.135 37.3284 193.722Z"
                fill={color}
            />
        </svg>
    );
}

export function ContactsSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 }, textAlign: 'center' }}>
                <FadeIn>
                    <Typography
                        level="h2"
                        sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                    >
                        Остались вопросы?
                    </Typography>
                    <Typography level="body-lg" sx={{ color: 'text.secondary', mb: 4 }}>
                        Задайте вопрос на почту.<br />Новости и жизнь проекта в Телеграме.
                    </Typography>
                </FadeIn>
                <FadeIn delay={0.15}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                        <Button
                            size="lg"
                            variant="soft"
                            component="a"
                            href="mailto:daniil@dybka.ru"
                            sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                        >
                            daniil@dybka.ru
                        </Button>
                        <Button
                            size="lg"
                            variant="soft"
                            component="a"
                            href="https://t.me/aquariumsocial"
                            target="_blank"
                            startDecorator={<TelegramIcon color="currentColor" />}
                            sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                        >
                            Телеграм-канал
                        </Button>
                    </Stack>
                </FadeIn>
            </Box>
        </Container>
    );
}
